import { Slot, usePathname } from "expo-router";
import { useEffect, useMemo, useRef } from "react";
import { ScrollView, StyleSheet } from "react-native";
import { HomeFooter } from "../../components";

import { Block, spacing, useBreakpoints } from "@stepapp/ui";

const AppContent = () => {
  const path = usePathname();
  const { md } = useBreakpoints();
  const scrollViewContent = useRef<ScrollView>(null);

  const hideWebFooter = useMemo(() => path.includes("reviews/frame"), [path]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: skip
  useEffect(() => {
    setTimeout(() => scrollViewContent?.current?.scrollTo({ x: 0, y: 0 }), 300);
  }, [path]);

  return (
    <ScrollView ref={scrollViewContent} style={styles.container}>
      <>
        <Block style={[styles.content, { paddingHorizontal: spacing.unit * (md ? 1.5 : 2.5) }]}>
          <Slot />
        </Block>

        {!hideWebFooter && <HomeFooter />}
      </>
    </ScrollView>
  );
};

export default AppContent;

const styles = StyleSheet.create({
  content: {
    alignSelf: "center",
    marginBottom: spacing.unit * 9,
    maxWidth: 1160,
    minHeight: spacing.deviceHeight - spacing.headerHeight,
    width: "100%",
  },
  container: {
    transform: "none",
  },
});
